import React, { useState } from "react";

const NewsForm = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("category", category);
    formData.append("file_url", fileUrl);

    try {
      const response = await fetch("http://localhost/eac_backend/save_news.php", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("News added successfully!");
        // Reset form fields
        setTitle("");
        setDescription("");
        setCategory("");
        setFileUrl("");
      } else {
        alert("Error adding news.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div>
      <h2>Submit News</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Title:
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </label>
        <label>
          Description:
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </label>
        <label>
          Category:
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
        </label>
        <label>
          File URL:
          <input
            type="text"
            value={fileUrl}
            onChange={(e) => setFileUrl(e.target.value)}
          />
        </label>
        <button type="submit">Submit News</button>
      </form>
    </div>
  );
};

export default NewsForm;
